<template>
  <div v-if="style" :style="style" ref="lavContainer"/>
</template>

<script>
import lottie from "lottie-web";
import axios from "axios";

export default {
  props: {
    path: {
      required: true
    },
    speed: {
      type: Number,
      required: false,
      default: 1
    },
    loop: {
      type:Boolean,
      required: false,
      default: true
    },
    autoPlay: {
      type:Boolean,
      required: false,
      default: true
    },
    icon: {
      type:String,
      required:true,
      default:''
    }
  },
  emits:['nojson','AnimControl','ready'],
  data: () => ({
    name: 'lottie-animation',
    rendererSettings: {
      scaleMode: "centerCrop",
      clearCanvas: true,
      progressiveLoad: false,
      hideOnTransparent: true
    },
    anim: null,
    style: null
  }),
  mounted() {
    this.init();
  },
  methods: {
    async loadJsonData(path) {

      if(!window.movingIconsAvailable){
        window.movingIconsAvailable = {};
      }
      
      let p;
      if(this.isURL(path)) p = path;
      else p = "/"+path;

      // if icon OR the await function is set, then return this automatically - i.e. no need to download again...
      if(window.movingIconsAvailable[this.icon]){
        return await window.movingIconsAvailable[this.icon];
      }else{
        window.movingIconsAvailable[this.icon] = axios.get(p).then(response => {
          if(!response.data){
            this.$emit('nojson')
          }else{
            window.movingIconsAvailable[this.icon] = response.data;
          }
          return response.data;
        }).catch(e => {
          this.$emit('nojson')
        });

        return await window.movingIconsAvailable[this.icon];
      }
    },
    isURL(path){
      // just something I stole from stack
      // https://stackoverflow.com/questions/5717093/check-if-a-javascript-string-is-a-url

      // heavily adapted for non-specific urls - ideal for the @ version number required by jsDelivr
      let urlpattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' // OR ip (v4) address
        ,'i'); // fragment locator

      return !!urlpattern.test(path);
    },
    async init() {
      this.style = {
        width: '100%',
        height: '100%',
        overflow: "hidden",
        margin: "0 auto"
      };

      let jsonData = await this.loadJsonData(this.path);

      if(this.anim) {
        this.anim.destroy(); // Releases resources. The DOM element will be emptied.
      }

      this.anim = lottie.loadAnimation({
        container: this.$refs.lavContainer,
        renderer: "svg",
        loop: this.loop,
        autoplay: this.autoPlay,
        animationData: jsonData,
        rendererSettings: this.rendererSettings
      });

      this.$emit("AnimControl", this.anim);
      this.anim.setSpeed(this.speed);
      this.$emit('ready')
    },
    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
    },
    executeLoop() {
      this.anim.play();
      setTimeout(() => {
        this.anim.stop();
        this.executeLoop();
      }, 0);
    },


  },
  watch: {
    path: function(newVal, oldVal) {
      this.init();
    }
  }
};
</script>